import { MARKET_SELECTABLE_PROVIDERS, type Currency } from '@etiquetachef/types';

/**
 * PSPs com cobrança no código e os padrões de um PSP integrado que ainda não
 * tem doc no catálogo `/config/psps`.
 *
 * Origem: #756 — 2026-10-01 13:31 +0200 (saiu do `PspListPage` para o editor
 * usar os mesmos valores).
 *
 * Usado por: `PspListPage.tsx` (linhas virtuais) e `PspEditorPage.tsx`
 * (formulário de um PSP ainda não cadastrado).
 */
export const CODE_INTEGRATED = new Set<string>(MARKET_SELECTABLE_PROVIDERS);

export const CODE_DEFAULTS: Record<string, { name: string; currencies: Currency[]; countries: string[] }> = {
  stripe: { name: 'Stripe', currencies: ['BRL', 'USD', 'EUR'], countries: [] },
  asaas: { name: 'Asaas', currencies: ['BRL'], countries: ['BR'] },
};
